// extracted by mini-css-extract-plugin
export default {"contentInnerContainer":"environments_contentInnerContainer__ZNxBg"};